export default __webpack_public_path__ + "static/media/8.4a3f46ea.png";